import React from 'react';
import { Button as RBButton } from 'react-bootstrap';

import './style.css';

const Button = ({ disabled, label, onClick, variant = 'primary' }) => {
    return (
        <div className="button">
            <RBButton variant={variant} onClick={onClick} disabled={disabled}>
                {label}
            </RBButton>
        </div>
    );
};

export default Button;
